import {
  isPartialMaterialCharacteristicsWithShade,
  type DeepPartial,
  type MaterialCharacteristics,
} from "@jasper/client-models";
import type { FieldValueProps } from "../../types";
import { Stack } from "@mantine/core";
import MaterialTypeSelect from "./MaterialTypeSelect";
import { ShadeCharacteristicsForm } from "../shade";
import { normalizeMaterialCharacteristics } from "./utils";

interface Props extends FieldValueProps<MaterialCharacteristics> {
  itemMaterials: { value: string; label: string }[];
  itemShadeTypes: { value: string; label: string }[];
  itemShades: { value: string; label: string }[];
}

export const MaterialCharacteristicsForm = ({
  value,
  errors,
  onChange,
  itemMaterials,
  itemShadeTypes,
  itemShades,
}: Props) => {
  const handleOnChange = (next: DeepPartial<MaterialCharacteristics>) =>
    onChange(normalizeMaterialCharacteristics(next));

  return (
    <Stack w="100%" gap="md">
      <Stack w="100%">
        <MaterialTypeSelect
          itemMaterials={itemMaterials}
          value={value?.material}
          errors={typeof errors === "string" ? errors : errors?.material}
          onChange={materialType => {
            handleOnChange({ ...value, material: materialType });
          }}
        />
      </Stack>

      {value && isPartialMaterialCharacteristicsWithShade(value) && (
        <>
          <ShadeCharacteristicsForm
            itemShadeTypes={itemShadeTypes}
            itemShades={itemShades}
            value={value.shadeCharacteristics}
            errors={
              errors &&
              typeof errors === "object" &&
              "shadeCharacteristics" in errors
                ? errors.shadeCharacteristics
                : undefined
            }
            onChange={shadeCharacteristics => {
              handleOnChange({ ...value, shadeCharacteristics });
            }}
          />
        </>
      )}
    </Stack>
  );
};
